<!--
 * @Date: 2023-08-25 15:53:49

-->
<template>
  <bk-view class="comm-res-item">
    <statusTag :curRows="item" />

    <res-record-base :item="item"></res-record-base>

    <bk-view class="book-view">
      <!-- <span>{{ resTime(item?.createDate?.displayValue) }}</span> -->
      <bk-button langCode="a_button_book_again" @click="$emit('book')"></bk-button>
    </bk-view>
  </bk-view>
</template>
  
<script>
	import ResRecordBase from '../resRecordBase/resRecordBase.vue';
	import statusTag from '../statusTag/statusTag.vue';
	import { dateMap } from '../../dataSource';
	import dayjs from 'dayjs';

	export default {
		name: 'CommResItem',
		components: { ResRecordBase, statusTag },
		props: {
			item: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		data () {
			return {
				languageType: this.$bk_getLanguageType(),
			};
		},

		computed: {
			resTime () {
				return (date) => {
					const _format = dateMap[this.languageType] || 'MM-DD HH:mm';
					return dayjs(date).format(_format);
				};
			}
		}
	};
</script>
  
<style lang='less' scoped>
 @import './commResItem.less';
</style>